export default class CourseRelative {
  readonly id: string
  readonly name: string
  readonly image: string
  readonly questionCount: number
  readonly answerCount: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.image = data.image
    this.questionCount = data.questionCount
    this.answerCount = data.answerCount
  }
}
